var map = {
	"./accordion/accordion.module": [
		"../../../../../src/app/components/basic/accordion/accordion.module.ts",
		"accordion.module"
	],
	"./account-card-to-card-add/account-card-to-card-add.module": [
		"../../../../../src/app/setting/account-card-to-card/account-card-to-card-add/account-card-to-card-add.module.ts",
		"common",
		"account-card-to-card-add.module"
	],
	"./account-card-to-card-list/account-card-to-card-list.module": [
		"../../../../../src/app/setting/account-card-to-card/account-card-to-card-list/account-card-to-card-list.module.ts",
		"common",
		"account-card-to-card-list.module"
	],
	"./account-card-to-card/account-card-to-card.module": [
		"../../../../../src/app/setting/account-card-to-card/account-card-to-card.module.ts",
		"account-card-to-card.module"
	],
	"./accountancy/accountancy.module": [
		"../../../../../src/app/accountancy/accountancy.module.ts",
		"accountancy.module"
	],
	"./add-on/add-on.module": [
		"../../../../../src/app/components/forms/add-on/add-on.module.ts",
		"add-on.module"
	],
	"./advance-elements/advance-elements.module": [
		"../../../../../src/app/components/forms/advance-elements/advance-elements.module.ts",
		"advance-elements.module"
	],
	"./alert/alert.module": [
		"../../../../../src/app/components/basic/alert/alert.module.ts",
		"alert.module"
	],
	"./animations/animations.module": [
		"../../../../../src/app/animations/animations.module.ts",
		"animations.module"
	],
	"./authentication/authentication.module": [
		"../../../../../src/app/authentication/authentication.module.ts",
		"authentication.module"
	],
	"./automatic-ending-job-add/automatic-ending-job-add.module": [
		"../../../../../src/app/automatic-ending-job/automatic-ending-job-add/automatic-ending-job-add.module.ts",
		"common",
		"automatic-ending-job-add.module"
	],
	"./automatic-ending-job-list/automatic-ending-job-list.module": [
		"../../../../../src/app/automatic-ending-job/automatic-ending-job-list/automatic-ending-job-list.module.ts",
		"common",
		"automatic-ending-job-list.module"
	],
	"./automatic-ending-job/automatic-ending-job.module": [
		"../../../../../src/app/automatic-ending-job/automatic-ending-job.module.ts",
		"automatic-ending-job.module"
	],
	"./backup-add/backup-add.module": [
		"../../../../../src/app/backup/backup-add/backup-add.module.ts",
		"common",
		"backup-add.module"
	],
	"./backup-list/backup-list.module": [
		"../../../../../src/app/backup/backup-list/backup-list.module.ts",
		"common",
		"backup-list.module"
	],
	"./backup/backup.module": [
		"../../../../../src/app/backup/backup.module.ts",
		"backup.module"
	],
	"./bank-add/bank-add.module": [
		"../../../../../src/app/setting/bank/bank-add/bank-add.module.ts",
		"common",
		"bank-add.module"
	],
	"./bank-list/bank-list.module": [
		"../../../../../src/app/setting/bank/bank-list/bank-list.module.ts",
		"common",
		"bank-list.module"
	],
	"./bank/bank.module": [
		"../../../../../src/app/setting/bank/bank.module.ts",
		"bank.module"
	],
	"./bankdari/bankdari.module": [
		"../../../../../src/app/bankdari/bankdari.module.ts",
		"bankdari.module"
	],
	"./basic-bootstrap/basic-bootstrap.module": [
		"../../../../../src/app/components/tables/bootstrap-table/basic-bootstrap/basic-bootstrap.module.ts",
		"basic-bootstrap.module"
	],
	"./basic-datatable/basic-datatable.module": [
		"../../../../../src/app/components/tables/data-table/basic-datatable/basic-datatable.module.ts",
		"basic-datatable.module"
	],
	"./basic-elements/basic-elements.module": [
		"../../../../../src/app/components/forms/basic-elements/basic-elements.module.ts",
		"basic-elements.module"
	],
	"./basic-invoice/basic-invoice.module": [
		"../../../../../src/app/components/invoice/basic-invoice/basic-invoice.module.ts",
		"basic-invoice.module"
	],
	"./board/board.module": [
		"../../../../../src/app/components/task/board/board.module.ts",
		"board.module"
	],
	"./border/border.module": [
		"../../../../../src/app/components/tables/bootstrap-table/border/border.module.ts",
		"border.module"
	],
	"./breadcrumb/breadcrumb.module": [
		"../../../../../src/app/components/basic/breadcrumb/breadcrumb.module.ts",
		"breadcrumb.module"
	],
	"./button/button.module": [
		"../../../../../src/app/components/basic/button/button.module.ts",
		"button.module"
	],
	"./c3-js/c3-js.module": [
		"../../../../../src/app/charts/c3-js/c3-js.module.ts",
		"common",
		"c3-js.module"
	],
	"./card-list/card-list.module": [
		"../../../../../src/app/card/card-list/card-list.module.ts",
		"common",
		"card-list.module"
	],
	"./card/card.module": [
		"../../../../../src/app/card/card.module.ts",
		"card.module"
	],
	"./change-log/change-log.module": [
		"../../../../../src/app/change-log/change-log.module.ts",
		"change-log.module"
	],
	"./chargenamovafagh/chargenamovafagh.module": [
		"../../../../../src/app/accountancy/chargenamovafagh/chargenamovafagh.module.ts",
		"common",
		"chargenamovafagh.module"
	],
	"./chart-js/chart-js.module": [
		"../../../../../src/app/charts/chart-js/chart-js.module.ts",
		"chart-js.module"
	],
	"./charts/charts.module": [
		"../../../../../src/app/charts/charts.module.ts",
		"charts.module"
	],
	"./child-row/child-row.module": [
		"../../../../../src/app/components/tables/data-table/child-row/child-row.module.ts",
		"child-row.module"
	],
	"./code-joz-add/code-joz-add.module": [
		"../../../../../src/app/copy/code-joz/code-joz-add/code-joz-add.module.ts",
		"common",
		"code-joz-add.module"
	],
	"./code-joz-list/code-joz-list.module": [
		"../../../../../src/app/copy/code-joz/code-joz-list/code-joz-list.module.ts",
		"common",
		"code-joz-list.module"
	],
	"./code-joz/code-joz.module": [
		"../../../../../src/app/copy/code-joz/code-joz.module.ts",
		"code-joz.module"
	],
	"./code-kol-add/code-kol-add.module": [
		"../../../../../src/app/copy/code-kol/code-kol-add/code-kol-add.module.ts",
		"common",
		"code-kol-add.module"
	],
	"./code-kol-list/code-kol-list.module": [
		"../../../../../src/app/copy/code-kol/code-kol-list/code-kol-list.module.ts",
		"common",
		"code-kol-list.module"
	],
	"./code-kol/code-kol.module": [
		"../../../../../src/app/copy/code-kol/code-kol.module.ts",
		"code-kol.module"
	],
	"./components/advance/advance.module": [
		"../../../../../src/app/components/advance/advance.module.ts",
		"advance.module"
	],
	"./components/basic/basic.module": [
		"../../../../../src/app/components/basic/basic.module.ts",
		"basic.module"
	],
	"./components/crm-contact/crm-contact.module": [
		"../../../../../src/app/components/crm-contact/crm-contact.module.ts",
		"crm-contact.module"
	],
	"./components/editor/editor.module": [
		"../../../../../src/app/components/editor/editor.module.ts",
		"editor.module"
	],
	"./components/file-upload/file-upload.module": [
		"../../../../../src/app/components/file-upload/file-upload.module.ts",
		"file-upload.module"
	],
	"./components/forms/forms.module": [
		"../../../../../src/app/components/forms/forms.module.ts",
		"forms.module"
	],
	"./components/invoice/invoice.module": [
		"../../../../../src/app/components/invoice/invoice.module.ts",
		"invoice.module"
	],
	"./components/tables/bootstrap-table/bootstrap-table.module": [
		"../../../../../src/app/components/tables/bootstrap-table/bootstrap-table.module.ts",
		"bootstrap-table.module"
	],
	"./components/tables/data-table/data-table.module": [
		"../../../../../src/app/components/tables/data-table/data-table.module.ts",
		"data-table.module"
	],
	"./components/task/task.module": [
		"../../../../../src/app/components/task/task.module.ts",
		"task.module"
	],
	"./compose-email/compose-email.module": [
		"../../../../../src/app/email/compose-email/compose-email.module.ts",
		"common",
		"compose-email.module"
	],
	"./copy/copy.module": [
		"../../../../../src/app/copy/copy.module.ts",
		"common",
		"copy.module"
	],
	"./daramad-dore/daramad-dore.module": [
		"../../../../../src/app/game/daramad-dore/daramad-dore.module.ts",
		"common",
		"daramad-dore.module"
	],
	"./dashboard-analytics/dashboard-analytics.module": [
		"../../../../../src/app/dashboard/dashboard-analytics/dashboard-analytics.module.ts",
		"common",
		"dashboard-analytics.module"
	],
	"./dashboard-crm/dashboard-crm.module": [
		"../../../../../src/app/dashboard/dashboard-crm/dashboard-crm.module.ts",
		"dashboard-crm.module"
	],
	"./dashboard-default/dashboard-default.module": [
		"../../../../../src/app/dashboard/dashboard-default/dashboard-default.module.ts",
		"common",
		"dashboard-default.module"
	],
	"./dashboard-ecommerce/dashboard-ecommerce.module": [
		"../../../../../src/app/dashboard/dashboard-ecommerce/dashboard-ecommerce.module.ts",
		"common",
		"dashboard-ecommerce.module"
	],
	"./dashboard-project/dashboard-project.module": [
		"../../../../../src/app/dashboard/dashboard-project/dashboard-project.module.ts",
		"common",
		"dashboard-project.module"
	],
	"./dashboard/dashboard.module": [
		"../../../../../src/app/dashboard/dashboard.module.ts",
		"common",
		"dashboard.module"
	],
	"./details/details.module": [
		"../../../../../src/app/components/task/details/details.module.ts",
		"details.module"
	],
	"./echart/echart.module": [
		"../../../../../src/app/charts/echart/echart.module.ts",
		"common",
		"echart.module"
	],
	"./email-inbox/email-inbox.module": [
		"../../../../../src/app/email/email-inbox/email-inbox.module.ts",
		"common",
		"email-inbox.module"
	],
	"./email-read/email-read.module": [
		"../../../../../src/app/email/email-read/email-read.module.ts",
		"common",
		"email-read.module"
	],
	"./email/email.module": [
		"../../../../../src/app/email/email.module.ts",
		"common",
		"email.module"
	],
	"./error/error.module": [
		"../../../../../src/app/error/error.module.ts",
		"error.module"
	],
	"./forgot/forgot.module": [
		"../../../../../src/app/authentication/forgot/forgot.module.ts",
		"forgot.module"
	],
	"./form-validation/form-validation.module": [
		"../../../../../src/app/components/forms/form-validation/form-validation.module.ts",
		"form-validation.module"
	],
	"./foroshe-namayandeh-kol/foroshe-namayandeh-kol.module": [
		"../../../../../src/app/game/foroshe-namayandeh-kol/foroshe-namayandeh-kol.module.ts",
		"common",
		"foroshe-namayandeh-kol.module"
	],
	"./foroshe-namayandeh/foroshe-namayandeh.module": [
		"../../../../../src/app/game/foroshe-namayandeh/foroshe-namayandeh.module.ts",
		"common",
		"foroshe-namayandeh.module"
	],
	"./froala-edit/froala-edit.module": [
		"../../../../../src/app/components/editor/froala-edit/froala-edit.module.ts",
		"froala-edit.module"
	],
	"./game-add/game-add.module": [
		"../../../../../src/app/game/game-add/game-add.module.ts",
		"common",
		"game-add.module"
	],
	"./game-finish/game-finish.module": [
		"../../../../../src/app/game/game-finish/game-finish.module.ts",
		"common",
		"game-finish.module"
	],
	"./game-help-add/game-help-add.module": [
		"../../../../../src/app/game-help/game-help-add/game-help-add.module.ts",
		"common",
		"game-help-add.module"
	],
	"./game-help-list/game-help-list.module": [
		"../../../../../src/app/game-help/game-help-list/game-help-list.module.ts",
		"common",
		"game-help-list.module"
	],
	"./game-help/game-help.module": [
		"../../../../../src/app/game-help/game-help.module.ts",
		"game-help.module"
	],
	"./game-list/game-list.module": [
		"../../../../../src/app/game/game-list/game-list.module.ts",
		"common",
		"game-list.module"
	],
	"./game-name-add/game-name-add.module": [
		"../../../../../src/app/game-name/game-name-add/game-name-add.module.ts",
		"common",
		"game-name-add.module"
	],
	"./game-name-list/game-name-list.module": [
		"../../../../../src/app/game-name/game-name-list/game-name-list.module.ts",
		"common",
		"game-name-list.module"
	],
	"./game-name/game-name.module": [
		"../../../../../src/app/game-name/game-name.module.ts",
		"game-name.module"
	],
	"./game-report/game-report.module": [
		"../../../../../src/app/game/game-report/game-report.module.ts",
		"common",
		"game-report.module"
	],
	"./game-type-add/game-type-add.module": [
		"../../../../../src/app/game-type/game-type-add/game-type-add.module.ts",
		"common",
		"game-type-add.module"
	],
	"./game-type-list/game-type-list.module": [
		"../../../../../src/app/game-type/game-type-list/game-type-list.module.ts",
		"common",
		"game-type-list.module"
	],
	"./game-type/game-type.module": [
		"../../../../../src/app/game-type/game-type.module.ts",
		"game-type.module"
	],
	"./game/game.module": [
		"../../../../../src/app/game/game.module.ts",
		"game.module"
	],
	"./generic-class/generic-class.module": [
		"../../../../../src/app/components/basic/generic-class/generic-class.module.ts",
		"common",
		"generic-class.module"
	],
	"./google/google.module": [
		"../../../../../src/app/charts/google/google.module.ts",
		"google.module"
	],
	"./inline-edit/inline-edit.module": [
		"../../../../../src/app/components/tables/data-table/inline-edit/inline-edit.module.ts",
		"inline-edit.module"
	],
	"./issue/issue.module": [
		"../../../../../src/app/components/task/issue/issue.module.ts",
		"issue.module"
	],
	"./knob/knob.module": [
		"../../../../../src/app/charts/knob/knob.module.ts",
		"knob.module"
	],
	"./label-badge/label-badge.module": [
		"../../../../../src/app/components/basic/label-badge/label-badge.module.ts",
		"label-badge.module"
	],
	"./landing/landing.module": [
		"../../../../../src/app/landing/landing.module.ts",
		"landing.module"
	],
	"./league-add/league-add.module": [
		"../../../../../src/app/league/league-add/league-add.module.ts",
		"common",
		"league-add.module"
	],
	"./league-list/league-list.module": [
		"../../../../../src/app/league/league-list/league-list.module.ts",
		"common",
		"league-list.module"
	],
	"./league/league.module": [
		"../../../../../src/app/league/league.module.ts",
		"league.module"
	],
	"./list-chart/list-chart.module": [
		"../../../../../src/app/charts/list-chart/list-chart.module.ts",
		"list-chart.module"
	],
	"./list/list.module": [
		"../../../../../src/app/components/invoice/list/list.module.ts",
		"list.module"
	],
	"./lock-screen/lock-screen.module": [
		"../../../../../src/app/authentication/lock-screen/lock-screen.module.ts",
		"lock-screen.module"
	],
	"./login/login.module": [
		"../../../../../src/app/authentication/login/login.module.ts",
		"login.module",
		"common"
	],
	"./maintenance/coming-soon/coming-soon.module": [
		"../../../../../src/app/maintenance/coming-soon/coming-soon.module.ts",
		"coming-soon.module"
	],
	"./maintenance/error/error.module": [
		"../../../../../src/app/maintenance/error/error.module.ts",
		"error.module.0"
	],
	"./maintenance/offline-ui/offline-ui.module": [
		"../../../../../src/app/maintenance/offline-ui/offline-ui.module.ts",
		"offline-ui.module"
	],
	"./manage-app-card-to-card/manage-app-card-to-card.module": [
		"../../../../../src/app/setting/manage-app-card-to-card/manage-app-card-to-card.module.ts",
		"common",
		"manage-app-card-to-card.module"
	],
	"./map/map.module": [
		"../../../../../src/app/map/map.module.ts",
		"map.module"
	],
	"./masking/masking.module": [
		"../../../../../src/app/components/forms/masking/masking.module.ts",
		"masking.module"
	],
	"./modal/modal.module": [
		"../../../../../src/app/components/advance/modal/modal.module.ts",
		"common",
		"modal.module"
	],
	"./mojodi-sandogh-users/mojodi-sandogh-users.module": [
		"../../../../../src/app/accountancy/mojodi-sandogh-users/mojodi-sandogh-users.module.ts",
		"common",
		"mojodi-sandogh-users.module"
	],
	"./morris-js/morris-js.module": [
		"../../../../../src/app/charts/morris-js/morris-js.module.ts",
		"morris-js.module"
	],
	"./mother-server-add/mother-server-add.module": [
		"../../../../../src/app/xml/mother-server/mother-server-add/mother-server-add.module.ts",
		"common",
		"mother-server-add.module"
	],
	"./mother-server-list/mother-server-list.module": [
		"../../../../../src/app/xml/mother-server/mother-server-list/mother-server-list.module.ts",
		"common",
		"mother-server-list.module"
	],
	"./mother-server/mother-server.module": [
		"../../../../../src/app/xml/mother-server/mother-server.module.ts",
		"mother-server.module"
	],
	"./namayandeh-joz-add/namayandeh-joz-add.module": [
		"../../../../../src/app/namayandeh/namayandeh-joz-add/namayandeh-joz-add.module.ts",
		"common",
		"namayandeh-joz-add.module"
	],
	"./namayandeh-joz-list/namayandeh-joz-list.module": [
		"../../../../../src/app/namayandeh/namayandeh-joz-list/namayandeh-joz-list.module.ts",
		"common",
		"namayandeh-joz-list.module"
	],
	"./namayandeh-kol-add/namayandeh-kol-add.module": [
		"../../../../../src/app/namayandeh/namayandeh-kol-add/namayandeh-kol-add.module.ts",
		"common",
		"namayandeh-kol-add.module"
	],
	"./namayandeh-kol-charge/namayandeh-kol-charge.module": [
		"../../../../../src/app/namayandeh/namayandeh-kol-charge/namayandeh-kol-charge.module.ts",
		"common",
		"namayandeh-kol-charge.module"
	],
	"./namayandeh-kol-list/namayandeh-kol-list.module": [
		"../../../../../src/app/namayandeh/namayandeh-kol-list/namayandeh-kol-list.module.ts",
		"common",
		"namayandeh-kol-list.module"
	],
	"./namayandeh/namayandeh.module": [
		"../../../../../src/app/namayandeh/namayandeh.module.ts",
		"namayandeh.module"
	],
	"./notifications/notifications.module": [
		"../../../../../src/app/components/advance/notifications/notifications.module.ts",
		"notifications.module"
	],
	"./notify/notify.module": [
		"../../../../../src/app/components/advance/notify/notify.module.ts",
		"notify.module"
	],
	"./nvd3/nvd3.module": [
		"../../../../../src/app/charts/nvd3/nvd3.module.ts",
		"common",
		"nvd3.module"
	],
	"./online-result/online-result.module": [
		"../../../../../src/app/game/online-result/online-result.module.ts",
		"online-result.module"
	],
	"./other/other.module": [
		"../../../../../src/app/components/tables/data-table/other/other.module.ts",
		"other.module"
	],
	"./paging/paging.module": [
		"../../../../../src/app/components/tables/data-table/paging/paging.module.ts",
		"paging.module"
	],
	"./paycardstocard/paycardstocard.module": [
		"../../../../../src/app/accountancy/paycardstocard/paycardstocard.module.ts",
		"common",
		"paycardstocard.module"
	],
	"./peity/peity.module": [
		"../../../../../src/app/charts/peity/peity.module.ts",
		"peity.module"
	],
	"./picker/picker.module": [
		"../../../../../src/app/components/forms/picker/picker.module.ts",
		"picker.module"
	],
	"./products-add/products-add.module": [
		"../../../../../src/app/products/products-add/products-add.module.ts",
		"common",
		"products-add.module"
	],
	"./products-groups-add/products-groups-add.module": [
		"../../../../../src/app/products-groups/products-groups-add/products-groups-add.module.ts",
		"common",
		"products-groups-add.module"
	],
	"./products-groups-list/products-groups-list.module": [
		"../../../../../src/app/products-groups/products-groups-list/products-groups-list.module.ts",
		"common",
		"products-groups-list.module"
	],
	"./products-groups/products-groups.module": [
		"../../../../../src/app/products-groups/products-groups.module.ts",
		"products-groups.module"
	],
	"./products-list/products-list.module": [
		"../../../../../src/app/products/products-list/products-list.module.ts",
		"common",
		"products-list.module"
	],
	"./products/products.module": [
		"../../../../../src/app/products/products.module.ts",
		"products.module"
	],
	"./profile/profile.module": [
		"../../../../../src/app/user/profile/profile.module.ts",
		"common",
		"profile.module"
	],
	"./questions-game-add/questions-game-add.module": [
		"../../../../../src/app/questions-game/questions-game-add/questions-game-add.module.ts",
		"common",
		"questions-game-add.module"
	],
	"./questions-game-list/questions-game-list.module": [
		"../../../../../src/app/questions-game/questions-game-list/questions-game-list.module.ts",
		"common",
		"questions-game-list.module"
	],
	"./questions-game/questions-game.module": [
		"../../../../../src/app/questions-game/questions-game.module.ts",
		"questions-game.module"
	],
	"./quill-edit/quill-edit.module": [
		"../../../../../src/app/components/editor/quill-edit/quill-edit.module.ts",
		"quill-edit.module"
	],
	"./radial/radial.module": [
		"../../../../../src/app/charts/radial/radial.module.ts",
		"radial.module"
	],
	"./registration/registration.module": [
		"../../../../../src/app/authentication/registration/registration.module.ts",
		"registration.module"
	],
	"./report-charge-admin/report-charge-admin.module": [
		"../../../../../src/app/accountancy/report-charge-admin/report-charge-admin.module.ts",
		"common",
		"report-charge-admin.module"
	],
	"./report-foroshe-namayandeh-kol/report-foroshe-namayandeh-kol.module": [
		"../../../../../src/app/game/report-foroshe-namayandeh-kol/report-foroshe-namayandeh-kol.module.ts",
		"common",
		"report-foroshe-namayandeh-kol.module"
	],
	"./report-namayandeh-kol-charge/report-namayandeh-kol-charge.module": [
		"../../../../../src/app/accountancy/report-namayandeh-kol-charge/report-namayandeh-kol-charge.module.ts",
		"common",
		"report-namayandeh-kol-charge.module"
	],
	"./reset-password/reset-password.module": [
		"../../../../../src/app/authentication/reset-password/reset-password.module.ts",
		"reset-password.module"
	],
	"./select/select.module": [
		"../../../../../src/app/components/forms/select/select.module.ts",
		"select.module"
	],
	"./selection/selection.module": [
		"../../../../../src/app/components/tables/data-table/selection/selection.module.ts",
		"selection.module"
	],
	"./setting-shop/setting-shop.module": [
		"../../../../../src/app/setting/setting-shop/setting-shop.module.ts",
		"common",
		"setting-shop.module"
	],
	"./setting-site/setting-site.module": [
		"../../../../../src/app/setting/setting-site/setting-site.module.ts",
		"common",
		"setting-site.module"
	],
	"./setting/setting.module": [
		"../../../../../src/app/setting/setting.module.ts",
		"common",
		"setting.module"
	],
	"./simple-page/simple-page.module": [
		"../../../../../src/app/simple-page/simple-page.module.ts",
		"simple-page.module"
	],
	"./sizing/sizing.module": [
		"../../../../../src/app/components/tables/bootstrap-table/sizing/sizing.module.ts",
		"sizing.module"
	],
	"./sms-add/sms-add.module": [
		"../../../../../src/app/setting/sms/sms-add/sms-add.module.ts",
		"common",
		"sms-add.module"
	],
	"./sms-list/sms-list.module": [
		"../../../../../src/app/setting/sms/sms-list/sms-list.module.ts",
		"common",
		"sms-list.module"
	],
	"./sms/sms.module": [
		"../../../../../src/app/setting/sms/sms.module.ts",
		"sms.module"
	],
	"./sparklines/sparklines.module": [
		"../../../../../src/app/charts/sparklines/sparklines.module.ts",
		"sparklines.module"
	],
	"./styling/styling.module": [
		"../../../../../src/app/components/tables/bootstrap-table/styling/styling.module.ts",
		"styling.module"
	],
	"./subusers/subusers.module": [
		"../../../../../src/app/user/subusers/subusers.module.ts",
		"common",
		"subusers.module"
	],
	"./summary/summary.module": [
		"../../../../../src/app/components/invoice/summary/summary.module.ts",
		"common",
		"summary.module"
	],
	"./supernamayandeh-add/supernamayandeh-add.module": [
		"../../../../../src/app/namayandeh/supernamayandeh-add/supernamayandeh-add.module.ts",
		"common",
		"supernamayandeh-add.module"
	],
	"./supernamayandeh-list/supernamayandeh-list.module": [
		"../../../../../src/app/namayandeh/supernamayandeh-list/supernamayandeh-list.module.ts",
		"common",
		"supernamayandeh-list.module"
	],
	"./tabs/tabs.module": [
		"../../../../../src/app/components/basic/tabs/tabs.module.ts",
		"common",
		"tabs.module"
	],
	"./takhfif-add/takhfif-add.module": [
		"../../../../../src/app/takhfif/takhfif-add/takhfif-add.module.ts",
		"common",
		"takhfif-add.module"
	],
	"./takhfif-list/takhfif-list.module": [
		"../../../../../src/app/takhfif/takhfif-list/takhfif-list.module.ts",
		"common",
		"takhfif-list.module"
	],
	"./takhfif/takhfif.module": [
		"../../../../../src/app/takhfif/takhfif.module.ts",
		"takhfif.module"
	],
	"./tarakonesh-bank/tarakonesh-bank.module": [
		"../../../../../src/app/accountancy/tarakonesh-bank/tarakonesh-bank.module.ts",
		"common",
		"tarakonesh-bank.module"
	],
	"./telegram-admin-add/telegram-admin-add.module": [
		"../../../../../src/app/setting/telegram-admin/telegram-admin-add/telegram-admin-add.module.ts",
		"common",
		"telegram-admin-add.module"
	],
	"./telegram-admin-list/telegram-admin-list.module": [
		"../../../../../src/app/setting/telegram-admin/telegram-admin-list/telegram-admin-list.module.ts",
		"common",
		"telegram-admin-list.module"
	],
	"./telegram-admin/telegram-admin.module": [
		"../../../../../src/app/setting/telegram-admin/telegram-admin.module.ts",
		"telegram-admin.module"
	],
	"./term-service/term-service.module": [
		"../../../../../src/app/setting/term-service/term-service.module.ts",
		"common",
		"term-service.module"
	],
	"./typography/typography.module": [
		"../../../../../src/app/components/basic/typography/typography.module.ts",
		"typography.module"
	],
	"./upload-bank-mehr/upload-bank-mehr.module": [
		"../../../../../src/app/bankdari/upload-bank-mehr/upload-bank-mehr.module.ts",
		"upload-bank-mehr.module",
		"common"
	],
	"./upload-excel/upload-excel.module": [
		"../../../../../src/app/bankdari/upload-excel/upload-excel.module.ts",
		"common",
		"upload-excel.module"
	],
	"./user-access-add/user-access-add.module": [
		"../../../../../src/app/user/user-access/user-access-add/user-access-add.module.ts",
		"common",
		"user-access-add.module"
	],
	"./user-access-list/user-access-list.module": [
		"../../../../../src/app/user/user-access/user-access-list/user-access-list.module.ts",
		"common",
		"user-access-list.module"
	],
	"./user-access/user-access.module": [
		"../../../../../src/app/user/user-access/user-access.module.ts",
		"user-access.module"
	],
	"./user-list/user-list.module": [
		"../../../../../src/app/user/user-list/user-list.module.ts",
		"common",
		"user-list.module"
	],
	"./user-valuable/user-valuable.module": [
		"../../../../../src/app/user/user-valuable/user-valuable.module.ts",
		"common",
		"user-valuable.module"
	],
	"./user/user.module": [
		"../../../../../src/app/user/user.module.ts",
		"user.module"
	],
	"./vector/vector.module": [
		"../../../../../src/app/map/vector/vector.module.ts",
		"vector.module"
	],
	"./voucher-add/voucher-add.module": [
		"../../../../../src/app/voucher/voucher-add/voucher-add.module.ts",
		"common",
		"voucher-add.module"
	],
	"./voucher-list/voucher-list.module": [
		"../../../../../src/app/voucher/voucher-list/voucher-list.module.ts",
		"common",
		"voucher-list.module"
	],
	"./voucher/voucher.module": [
		"../../../../../src/app/voucher/voucher.module.ts",
		"voucher.module"
	],
	"./widget/widget.module": [
		"../../../../../src/app/widget/widget.module.ts",
		"widget.module",
		"common"
	],
	"./withdrawal/withdrawal.module": [
		"../../../../../src/app/accountancy/withdrawal/withdrawal.module.ts",
		"common",
		"withdrawal.module"
	],
	"./xml/xml.module": [
		"../../../../../src/app/xml/xml.module.ts",
		"common",
		"xml.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = "../../../../../src/$$_gendir lazy recursive";


//////////////////
// WEBPACK FOOTER
// D:/Projects/Hb.Bet/ServerAPI/AdminAngular/src/$$_gendir lazy
// module id = ../../../../../src/$$_gendir lazy recursive
// module chunks = main